<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div id="header" class="app-header">
        <!-- BEGIN mobile-toggler -->
        <div class="mobile-toggler">
            <button type="button" class="menu-toggler" v-on:click="toggleAppSidebarMobile">
                <span class="bar"></span>
                <span class="bar"></span>
            </button>
        </div>
        <!-- END mobile-toggler -->

        <!-- BEGIN brand -->
        <div class="brand">
            <div class="desktop-toggler">
                <button type="button" class="menu-toggler" v-on:click="toggleAppSidebarMinify">
                    <span class="bar"></span>
                    <span class="bar"></span>
                </button>
            </div>
            <a href="#" class="brand-logo">
                <img src="/assets/img/logo.png" alt="" height="30"/>
                <!--<span>TRM</span>-->
            </a>
        </div>
        <!-- END brand -->

        <!-- BEGIN menu -->
        <div class="menu">
            <form class="menu-search" name="header_search_form" v-on:submit="checkForm">
                <div class="menu-search-icon"><i class="fa fa-search"></i></div>
                <div class="menu-search-input">
                    <input type="text" class="form-control" placeholder="SearchMenu" v-model="inputMenu"/>
                </div>
            </form>
            <!--user info-->
            <b-dropdown  class="menu-item" right toggle-tag="a" variant="link" :no-caret="true"
                        toggle-class="menu-link border-0">
                <template v-slot:button-content>
                    <div class="menu-img online">
                        <div
                            class="d-flex align-items-center justify-content-center w-100 h-100 bg-gray-800 text-gray-300 rounded-circle overflow-hidden">
                            <i class="fa fa-user fa-2x mb-n3"></i>
                        </div>
                    </div>
                    <!--<div class="menu-text">{{userInfo.login}}</div>-->
                    <div class="menu-text">admin</div>
                </template>
                <b-dropdown-item link-class="d-flex align-items-center" @click="logOut">
                    {{ $t('GENERAL.LogOut') }} <i class="fa fa-toggle-off fa-fw ml-auto text-gray-400 f-s-16"></i>
                </b-dropdown-item>
            </b-dropdown>

            <!--<router-link v-else to="/login">-->
                <!--<b-button class="mr-2" size="sm" variant="success">Login</b-button>-->
            <!--</router-link>-->

        </div>
        <!-- END menu -->
    </div>
</template>

<script>
    import AppOptions from '../config/AppOptions.vue'

    export default {
        name: 'Header',
        data() {
            return {
                appOptions: AppOptions,
                notificationData: [],
                inputMenu:'',
            }
        },
        computed: {
            // I18N
            getCurrentLocaleData() {
                const locale = this.$i18n.locale;
                if (locale === "en") return {lang: 'EN'}
                else if (locale === "tw") return {lang: '繁體'}
                else return {lang: '简体'}
            },
            //获取用户信息
            userInfo() {
                return this.$store.getters.getUserInfo;
            }
        },
        methods: {
            toggleAppSidebarMobile() {
                this.appOptions.appSidebarMobileToggled = !this.appOptions.appSidebarMobileToggled;
            },
            toggleAppSidebarMinify() {
                this.appOptions.appSidebarMinified = !this.appOptions.appSidebarMinified;
            },
            checkForm: function (e) {
                console.log(e)
                e.preventDefault();
                this.$router.push({path: '/'+this.inputMenu})
            },
            updateLocale(locale) {  //set language
                this.$i18n.locale = locale;
                const lang = locale;
                this.setActiveLanguage(lang);
                return history.go(0)
            },
            setActiveLanguage(lang) {
                localStorage.setItem('language', lang)
            },
            logOut() { //退出
                const token = localStorage.getItem('token');
                const done = () => {
                    localStorage.removeItem('token');
                    localStorage.removeItem('uid');
                    this.$router.push({path: '/login'});
                };
                this.$axios({
                    method: 'post',
                    url: 'https://gamejava.monkeytree.com.hk/vue/signOut?token=' + token,
                    withCredentials: true
                }).then(done).catch(done);
            }
        },
        mounted() {
            //获取用户信息
            // this.$axios({
            //     method: 'get',
            //     url: this.GLOBAL.rootPath + '/user/getUser',
            // }) .then(res => {
            //     this.$store.dispatch('updateUserData', res.data.user);
            //     this.GLOBAL.userId = this.$store.getters.getUserInfo.userId;//存儲用戶id
            // }).catch(error => {
            //     console.log(error);
            // });
        },
        created() {
            if (this.userInfo === false) {
                this.$router.push('/login')
            }
        }
    }
</script>
